<template lang="pug">
UiModal(
  :title="title"
  :show="show"
  @close="close"
  width="800"
)
  p(v-for="row in original_record") {{ row }}
</template>

<script>
export default {
  data() {
    return {
      show: false,
      inProgress: false,
      invoice_number: "",
      original_record: "",
    };
  },

  computed: {
    title() {
      return this.$t("digia.show_invoice_record_modal.title", {
        invoice_number: this.invoice_number,
      });
    },
  },

  methods: {
    open({ original_record, invoice_number }) {
      this.invoice_number = invoice_number;
      this.original_record = original_record;
      this.show = true;
    },

    close() {
      this.show = false;
    },
  },
};
</script>
